import { render, staticRenderFns } from "./MoleculeInitialAccess.vue?vue&type=template&id=28e0cafc&"
import script from "./MoleculeInitialAccess.vue?vue&type=script&lang=js&"
export * from "./MoleculeInitialAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports